import { DumpsterSize, Pricing } from "../../../models";
import { RawPricing } from "../normalizers/getPricing";

export function pricing(p: Pricing): RawPricing {
  const s = p.dumpsterRentalBySize;
  return {
    dumpster_rental_by_size: {
      [DumpsterSize.SIZE_10]: String(s[DumpsterSize.SIZE_10]),
      [DumpsterSize.SIZE_15]: String(s[DumpsterSize.SIZE_15]),
      [DumpsterSize.SIZE_CLEAN_FILL]: String(s[DumpsterSize.SIZE_CLEAN_FILL]),
    },
    overweight_per_pound: String(p.overweightPerPound),
  };
}
